import { render, staticRenderFns } from "./status-select.vue?vue&type=template&id=2a663492&scoped=true&"
import script from "./status-select.vue?vue&type=script&lang=js&"
export * from "./status-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a663492",
  null
  
)

export default component.exports